<template>
  <div :style="computedStyle" :class="className"></div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 15
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedStyle() {
      if (this.vertical) {
        return {
          minHeight: `${this.size}px`
        };
      }
      return undefined;
    },
    className() {
      // Default is horizontal divider
      return this.vertical ? "vertical" : "horizontal";
    }
  }
};
</script>

<style lang="scss" scoped>
.horizontal {
  border-top: 1px solid var(--gray-border-color);
  margin: 10px 0;
}
.vertical {
  border-left: 1px solid var(--gray-border-color);
  margin: 0 10px;
}
</style>
